export default __webpack_public_path__ + "static/media/GYANA RANJAN BISWAL.0af0cf3a.jpeg";